@if (loading()) {
  <rr-ui-core-ellipsis-loader [themeLoader]="authStore.themeLoader()" class="loader" />
} @else {
  <router-outlet />

  @if (showDataPrivacy()) {
    <rr-data-privacy (confirm)="showDataPrivacy.set(false)" />
  }
}

@if (apiStore.show()) {
  <rr-error-modal />
}

<p-confirm-dialog />
<p-toast />
